/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RadioboxFieldFromJSON, RadioboxFieldToJSON, } from './RadioboxField';
import { StringFieldFromJSON, StringFieldToJSON, } from './StringField';
/**
 * Check if a given object implements the TerminalePosSection interface.
 */
export function instanceOfTerminalePosSection(value) {
    let isInstance = true;
    return isInstance;
}
export function TerminalePosSectionFromJSON(json) {
    return TerminalePosSectionFromJSONTyped(json, false);
}
export function TerminalePosSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'noloDelTerminalePos': !exists(json, 'noloDelTerminalePos') ? undefined : StringFieldFromJSON(json['noloDelTerminalePos']),
        'attivazioneTerminalePos': !exists(json, 'attivazioneTerminalePos') ? undefined : StringFieldFromJSON(json['attivazioneTerminalePos']),
        'attivazioneInstallazioneTerminalePosInLoco': !exists(json, 'attivazioneInstallazioneTerminalePosInLoco') ? undefined : StringFieldFromJSON(json['attivazioneInstallazioneTerminalePosInLoco']),
        'costoGateway': !exists(json, 'costoGateway') ? undefined : StringFieldFromJSON(json['costoGateway']),
        'interventoManutenzioneTerminalePos': !exists(json, 'interventoManutenzioneTerminalePos') ? undefined : StringFieldFromJSON(json['interventoManutenzioneTerminalePos']),
        'acquistoTerminalePos': !exists(json, 'acquistoTerminalePos') ? undefined : StringFieldFromJSON(json['acquistoTerminalePos']),
        'materialeDiConsumo': !exists(json, 'materialeDiConsumo') ? undefined : StringFieldFromJSON(json['materialeDiConsumo']),
        'terminalePosDal': !exists(json, 'terminalePosDal') ? undefined : StringFieldFromJSON(json['terminalePosDal']),
        'terminalePosAl': !exists(json, 'terminalePosAl') ? undefined : StringFieldFromJSON(json['terminalePosAl']),
        'abiBanca': !exists(json, 'abiBanca') ? undefined : StringFieldFromJSON(json['abiBanca']),
        'nomeGestore': !exists(json, 'nomeGestore') ? undefined : StringFieldFromJSON(json['nomeGestore']),
        'posVirtualYes': !exists(json, 'posVirtualYes') ? undefined : RadioboxFieldFromJSON(json['posVirtualYes']),
        'posVirtualNo': !exists(json, 'posVirtualNo') ? undefined : RadioboxFieldFromJSON(json['posVirtualNo']),
        'shopSign': !exists(json, 'shopSign') ? undefined : StringFieldFromJSON(json['shopSign']),
        'shopAddress': !exists(json, 'shopAddress') ? undefined : StringFieldFromJSON(json['shopAddress']),
        'shopCAP': !exists(json, 'shopCAP') ? undefined : StringFieldFromJSON(json['shopCAP']),
        'shopCity': !exists(json, 'shopCity') ? undefined : StringFieldFromJSON(json['shopCity']),
        'shopProvince': !exists(json, 'shopProvince') ? undefined : StringFieldFromJSON(json['shopProvince']),
        'shopPhonePrefix': !exists(json, 'shopPhonePrefix') ? undefined : StringFieldFromJSON(json['shopPhonePrefix']),
        'shopPhone': !exists(json, 'shopPhone') ? undefined : StringFieldFromJSON(json['shopPhone']),
        'shopDescription': !exists(json, 'shopDescription') ? undefined : StringFieldFromJSON(json['shopDescription']),
        'shopService': !exists(json, 'shopService') ? undefined : StringFieldFromJSON(json['shopService']),
        'shopCode': !exists(json, 'shopCode') ? undefined : StringFieldFromJSON(json['shopCode']),
        'shopInternetSellingYes': !exists(json, 'shopInternetSellingYes') ? undefined : RadioboxFieldFromJSON(json['shopInternetSellingYes']),
        'shopInternetSellingNo': !exists(json, 'shopInternetSellingNo') ? undefined : RadioboxFieldFromJSON(json['shopInternetSellingNo']),
        'shopTypeYes': !exists(json, 'shopTypeYes') ? undefined : RadioboxFieldFromJSON(json['shopTypeYes']),
        'shopTypeNo': !exists(json, 'shopTypeNo') ? undefined : RadioboxFieldFromJSON(json['shopTypeNo']),
        'shopPhoneSellingYes': !exists(json, 'shopPhoneSellingYes') ? undefined : RadioboxFieldFromJSON(json['shopPhoneSellingYes']),
        'shopPhoneSellingNo': !exists(json, 'shopPhoneSellingNo') ? undefined : RadioboxFieldFromJSON(json['shopPhoneSellingNo']),
        'bankDescription': !exists(json, 'bankDescription') ? undefined : StringFieldFromJSON(json['bankDescription']),
        'iban': !exists(json, 'iban') ? undefined : StringFieldFromJSON(json['iban']),
        'ccDescription': !exists(json, 'ccDescription') ? undefined : StringFieldFromJSON(json['ccDescription']),
    };
}
export function TerminalePosSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'noloDelTerminalePos': StringFieldToJSON(value.noloDelTerminalePos),
        'attivazioneTerminalePos': StringFieldToJSON(value.attivazioneTerminalePos),
        'attivazioneInstallazioneTerminalePosInLoco': StringFieldToJSON(value.attivazioneInstallazioneTerminalePosInLoco),
        'costoGateway': StringFieldToJSON(value.costoGateway),
        'interventoManutenzioneTerminalePos': StringFieldToJSON(value.interventoManutenzioneTerminalePos),
        'acquistoTerminalePos': StringFieldToJSON(value.acquistoTerminalePos),
        'materialeDiConsumo': StringFieldToJSON(value.materialeDiConsumo),
        'terminalePosDal': StringFieldToJSON(value.terminalePosDal),
        'terminalePosAl': StringFieldToJSON(value.terminalePosAl),
        'abiBanca': StringFieldToJSON(value.abiBanca),
        'nomeGestore': StringFieldToJSON(value.nomeGestore),
        'posVirtualYes': RadioboxFieldToJSON(value.posVirtualYes),
        'posVirtualNo': RadioboxFieldToJSON(value.posVirtualNo),
        'shopSign': StringFieldToJSON(value.shopSign),
        'shopAddress': StringFieldToJSON(value.shopAddress),
        'shopCAP': StringFieldToJSON(value.shopCAP),
        'shopCity': StringFieldToJSON(value.shopCity),
        'shopProvince': StringFieldToJSON(value.shopProvince),
        'shopPhonePrefix': StringFieldToJSON(value.shopPhonePrefix),
        'shopPhone': StringFieldToJSON(value.shopPhone),
        'shopDescription': StringFieldToJSON(value.shopDescription),
        'shopService': StringFieldToJSON(value.shopService),
        'shopCode': StringFieldToJSON(value.shopCode),
        'shopInternetSellingYes': RadioboxFieldToJSON(value.shopInternetSellingYes),
        'shopInternetSellingNo': RadioboxFieldToJSON(value.shopInternetSellingNo),
        'shopTypeYes': RadioboxFieldToJSON(value.shopTypeYes),
        'shopTypeNo': RadioboxFieldToJSON(value.shopTypeNo),
        'shopPhoneSellingYes': RadioboxFieldToJSON(value.shopPhoneSellingYes),
        'shopPhoneSellingNo': RadioboxFieldToJSON(value.shopPhoneSellingNo),
        'bankDescription': StringFieldToJSON(value.bankDescription),
        'iban': StringFieldToJSON(value.iban),
        'ccDescription': StringFieldToJSON(value.ccDescription),
    };
}
